import React, { useEffect } from "react";

import { useModal } from "../../../../providers/ModalProvider/ModalProvider";

import Button from "react-bootstrap/Button";

import { SeatMapNavigation } from "../../../SeatMapNavigation";
import { ExchangeTickets } from "../ExchangeTickets";
import { Error } from "../../../ModalContent";

export default function Navigation({
  event,
  isMapDisabled,
  configuration,
  selectedSeatIds,
  handleGoBack,
  isDisabled,
  fromOrder,
  fromEvent,
  fromTickets,
  setIsAnotherModalOpen,
}) {
  const { openModal, closeModal } = useModal();

  useEffect(() => {}, [selectedSeatIds]);

  const openExchangeModal = () => {
    const GASectionsSelected = Object.values(selectedSeatIds?.gaSeats || {});
    const seatsSelected = Object.values(selectedSeatIds?.seats || {});

    // Count GA tickets by summing array lengths
    const gaTicketsCount = GASectionsSelected.reduce(
      (total, section) => total + section.length,
      0,
    );

    const numSelectedTickets = gaTicketsCount + seatsSelected.length;

    if (numSelectedTickets !== fromTickets.length) {
      setIsAnotherModalOpen(true);
      openModal(
        Error,
        {
          title: "Cannot Select Seats",
          description: "You can only exchange the same amount of seats",
          onClose: () => {
            setIsAnotherModalOpen(false);
            closeModal();
          },
        },
        { className: "modal-sm" },
        { replace: false },
      );
      return;
    }

    // This is dumb
    if (GASectionsSelected.length > 1) {
      setIsAnotherModalOpen(true);
      openModal(
        Error,
        {
          title: "Cannot Select Seats",
          description:
            "You can only select seats from either GA or seated sections at a time...",
          onClose: () => {
            setIsAnotherModalOpen(false);
            closeModal();
          },
        },
        { className: "modal-sm" },
        { replace: false },
      );
      return;
    }

    // This is also dumb
    if (GASectionsSelected.length > 0 && seatsSelected.length > 0) {
      setIsAnotherModalOpen(true);
      openModal(
        Error,
        {
          title: "Cannot Select Seats",
          description:
            "You can only select seats from either GA or seated sections at a time...",
          onClose: () => {
            setIsAnotherModalOpen(false);
            closeModal();
          },
        },
        { className: "modal-sm" },
        { replace: false },
      );
      return;
    }

    openModal(
      () => (
        <ExchangeTickets
          event={event}
          fromEventName={fromEvent?.name}
          fromEventDate={fromEvent?.start}
          fromEmail={fromOrder?.email}
          selectedSeatIds={selectedSeatIds}
          fromTickets={fromTickets}
        />
      ),
      {},
      { className: "modal--lg", scrollable: false },
      { replace: false },
    );
  };

  const getButton = () => {
    return (
      <Button
        onClick={openExchangeModal}
        disabled={
          isDisabled ||
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0
        }
      >
        Exchange tickets
      </Button>
    );
  };

  return (
    <SeatMapNavigation
      event={event}
      configuration={configuration}
      showReset={false}
      handleLeave={handleGoBack}
      getButton={getButton}
    />
  );
}
